<div class="datetime-picker">
    @if (tableStyle) {
        <input
            [formControl]="fc"
            [matDatepicker]="picker"
            [name]="field.name"
            [placeholder]="field.name"
            [min]="field.validators?.minDate"
            [max]="field.validators?.maxDate"
            (click)="picker.open()"
            matInput
            readonly />

        @if (fc.value && !fc.disabled) {
            <button (click)="fc.setValue(null)" matSuffix mat-icon-button>
                <mat-icon fontSet="fas" fontIcon="fa-x"></mat-icon>
            </button>
        }

        @if (!fc.value && !fc.disabled) {
            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        }

        <mat-datepicker #picker></mat-datepicker>

        <mat-error [control]="fc"></mat-error>
    } @else {
        <mat-form-field [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'" appearance="fill">
            @if (!fc.disabled) {
                <mat-label>{{ field.name }}</mat-label>
            }

            <input
                [formControl]="fc"
                [matDatepicker]="picker"
                [name]="field.name"
                [placeholder]="fc.disabled ? '' : field.name"
                [min]="field.validators?.minDate"
                [max]="field.validators?.maxDate"
                (click)="picker.open()"
                matInput
                readonly />

            @if (fc.value && !fc.disabled) {
                <button (click)="fc.setValue(null)" matSuffix mat-icon-button>
                    <mat-icon fontSet="fas" fontIcon="fa-x"></mat-icon>
                </button>
            }

            @if (!fc.value && !fc.disabled) {
                <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
            }

            <mat-datepicker #picker></mat-datepicker>

            <mat-error [control]="fc"></mat-error>
        </mat-form-field>
    }
</div>
